import React from "react";
import CookieConsent from "react-cookie-consent";
import { Link } from "react-router-dom";

const CookieBanner = () => {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Alle akzeptieren"
      declineButtonText="Nur essenzielle"
      enableDeclineButton
      cookieName="bbs2_bewerbung_cookie_consent"
      style={{
        background: "#1e293b",
        color: "#f8fafc",
        fontSize: "14px",
        alignItems: "center",
        padding: "10px 20px",
        zIndex: 9999
      }}
      buttonStyle={{
        background: "#2563eb",
        color: "#ffffff",
        fontSize: "14px",
        fontWeight: "600",
        borderRadius: "6px",
        padding: "8px 16px"
      }}
      declineButtonStyle={{
        background: "transparent",
        border: "1px solid #94a3b8",
        color: "#e2e8f0",
        fontSize: "14px",
        borderRadius: "6px",
        padding: "8px 16px"
      }}
      expires={150}
      onAccept={() => {
        console.log("Cookies akzeptiert");
      }}
      onDecline={() => {
        console.log("Nur essenzielle Cookies zugelassen");
      }}
    >
      Wir nutzen technisch notwendige Cookies, um die Funktion des Bewerbungsportals zu gewährleisten.{" "}
      <Link to="/DataProtection">Datenschutz</Link>
    </CookieConsent>
  );
};

export default CookieBanner;